import 'twin.macro';
import React from 'react';
import { css } from '@emotion/react';

export function CenterRotatedCell({
  children,
  className,
  active,
}: {
  children: any;
  className?: string;
  active: boolean;
}) {
  if (!active) {
    if (!className) {
      return children;
    }
    return <span className={className}>{children}</span>;
  }
  // https://stackoverflow.com/questions/15806925/how-to-rotate-text-left-90-degree-and-cell-size-is-adjusted-according-to-text-in
  return (
    <span
      className={className}
      css={css`
        transform: rotate(180deg);
        -ms-writing-mode: tb-rl;
        -webkit-writing-mode: vertical-rl;
        writing-mode: vertical-rl;
      `}
      tw="whitespace-nowrap"
    >
      {children}
    </span>
  );
}
